"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissKeyError = exports.DownloadSampleApiLimitError = exports.FetchSampleInfoError = exports.DownloadSampleNetworkError = exports.UnzipError = exports.ScaffoldLocalTemplateError = exports.TemplateNotFoundError = exports.SampleNotFoundError = exports.CancelDownloading = void 0;
const tslib_1 = require("tslib");
const componentError_1 = require("../error/componentError");
const constant_1 = require("./constant");
const axios_1 = tslib_1.__importDefault(require("axios"));
const utils_1 = require("./utils");
class CancelDownloading extends Error {
}
exports.CancelDownloading = CancelDownloading;
class SampleNotFoundError extends componentError_1.BaseComponentInnerError {
    constructor(templateName) {
        super(constant_1.errorSource, "SystemError", "SampleNotFoundError", "error.generator.SampleNotFoundError", [templateName]);
    }
}
exports.SampleNotFoundError = SampleNotFoundError;
class TemplateNotFoundError extends componentError_1.BaseComponentInnerError {
    constructor(templateName) {
        super(constant_1.errorSource, "SystemError", "TemplateNotFoundError", "error.generator.TemplateNotFoundError", [templateName]);
    }
}
exports.TemplateNotFoundError = TemplateNotFoundError;
class ScaffoldLocalTemplateError extends componentError_1.BaseComponentInnerError {
    constructor(error) {
        super(constant_1.errorSource, "SystemError", "ScaffoldLocalTemplateError", "error.generator.ScaffoldLocalTemplateError", undefined, undefined, undefined, undefined, error);
    }
}
exports.ScaffoldLocalTemplateError = ScaffoldLocalTemplateError;
class UnzipError extends componentError_1.BaseComponentInnerError {
    constructor() {
        super(constant_1.errorSource, "SystemError", "UnzipError", "error.generator.UnzipError", undefined, [
            "plugins.frontend.checkFsPermissionsTip",
        ]);
    }
}
exports.UnzipError = UnzipError;
class DownloadSampleNetworkError extends componentError_1.BaseComponentInnerError {
    constructor(url, error) {
        const innerError = axios_1.default.isAxiosError(error) ? (0, utils_1.simplifyAxiosError)(error) : error;
        super(constant_1.errorSource, "UserError", "DownloadSampleNetworkError", "error.generator.DownloadSampleNetworkError", [url], undefined, undefined, undefined, innerError);
    }
}
exports.DownloadSampleNetworkError = DownloadSampleNetworkError;
class FetchSampleInfoError extends componentError_1.BaseComponentInnerError {
    constructor(error) {
        const innerError = axios_1.default.isAxiosError(error) ? (0, utils_1.simplifyAxiosError)(error) : error;
        super(constant_1.errorSource, "UserError", "FetchSampleInfoError", "error.generator.FetchSampleInfoError", undefined, undefined, undefined, undefined, innerError);
    }
}
exports.FetchSampleInfoError = FetchSampleInfoError;
class DownloadSampleApiLimitError extends componentError_1.BaseComponentInnerError {
    constructor(url, error) {
        const innerError = axios_1.default.isAxiosError(error) ? (0, utils_1.simplifyAxiosError)(error) : error;
        super(constant_1.errorSource, "UserError", "DownloadSampleApiLimitError", "error.generator.DownloadSampleApiLimitError", [url], undefined, undefined, undefined, innerError);
    }
}
exports.DownloadSampleApiLimitError = DownloadSampleApiLimitError;
class MissKeyError extends componentError_1.BaseComponentInnerError {
    constructor(keyName) {
        super(constant_1.errorSource, "SystemError", "MissKeyError", "error.generator.MissKeyError", [keyName]);
    }
}
exports.MissKeyError = MissKeyError;
//# sourceMappingURL=error.js.map